"use strict";

var _regeneratorRuntime = require("C:\\Projects\\far-fruit\\node_modules\\@babel\\runtime\\regenerator\\index.js");

var _slicedToArray = require("C:\\Projects\\far-fruit\\node_modules\\@babel\\runtime\\helpers\\slicedToArray.js");

var _asyncToGenerator = require("C:\\Projects\\far-fruit\\node_modules\\@babel\\runtime\\helpers\\asyncToGenerator.js");

var _classCallCheck = require("C:\\Projects\\far-fruit\\node_modules\\@babel\\runtime\\helpers\\classCallCheck.js");

var _createClass = require("C:\\Projects\\far-fruit\\node_modules\\@babel\\runtime\\helpers\\createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Canvas = void 0;

var Utils_1 = require("./Utils");

var Utils_2 = require("../Utils");

var Canvas = /*#__PURE__*/function () {
  function Canvas(container) {
    _classCallCheck(this, Canvas);

    this.container = container;
    this.size = {
      height: 0,
      width: 0
    };
    this.context = null;
    this.generatedCanvas = false;
  }

  _createClass(Canvas, [{
    key: "init",
    value: function init() {
      this.resize();
      this.initStyle();
      this.initCover();
      this.initTrail();
      this.initBackground();
      this.paint();
    }
  }, {
    key: "loadCanvas",
    value: function loadCanvas(canvas) {
      var _a;

      if (this.generatedCanvas) {
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
      }

      this.generatedCanvas = canvas.dataset && Utils_1.Constants.generatedAttribute in canvas.dataset ? canvas.dataset[Utils_1.Constants.generatedAttribute] === "true" : this.generatedCanvas;
      this.element = canvas;
      this.originalStyle = (0, Utils_2.deepExtend)({}, this.element.style);
      this.size.height = canvas.offsetHeight;
      this.size.width = canvas.offsetWidth;
      this.context = this.element.getContext("2d");
      this.container.retina.init();
      this.initBackground();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this = this;

      var _a;

      if (this.generatedCanvas) {
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
      }

      this.draw(function (ctx) {
        (0, Utils_2.clear)(ctx, _this.size);
      });
    }
  }, {
    key: "paint",
    value: function paint() {
      var _this2 = this;

      var options = this.container.actualOptions;
      this.draw(function (ctx) {
        if (options.backgroundMask.enable && options.backgroundMask.cover && _this2.coverColor) {
          (0, Utils_2.clear)(ctx, _this2.size);

          _this2.paintBase((0, Utils_2.getStyleFromRgb)(_this2.coverColor, _this2.coverColor.a));
        } else {
          _this2.paintBase();
        }
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this3 = this;

      var options = this.container.actualOptions;
      var trail = options.particles.move.trail;

      if (options.backgroundMask.enable) {
        this.paint();
      } else if (trail.enable && trail.length > 0 && this.trailFillColor) {
        this.paintBase((0, Utils_2.getStyleFromRgb)(this.trailFillColor, 1 / trail.length));
      } else {
        this.draw(function (ctx) {
          (0, Utils_2.clear)(ctx, _this3.size);
        });
      }
    }
  }, {
    key: "windowResize",
    value: function () {
      var _windowResize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var container, needsRefresh, _iterator, _step, _step$value, plugin;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.element) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                container = this.container;
                this.resize();
                needsRefresh = container.updateActualOptions();
                container.particles.setDensity();
                _iterator = _createForOfIteratorHelper(container.plugins);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _step$value = _slicedToArray(_step.value, 2), plugin = _step$value[1];

                    if (plugin.resize !== undefined) {
                      plugin.resize();
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                if (!needsRefresh) {
                  _context.next = 11;
                  break;
                }

                _context.next = 11;
                return container.refresh();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function windowResize() {
        return _windowResize.apply(this, arguments);
      }

      return windowResize;
    }()
  }, {
    key: "resize",
    value: function resize() {
      if (!this.element) {
        return;
      }

      var container = this.container;
      var pxRatio = container.retina.pixelRatio;
      var size = container.canvas.size;
      var oldSize = {
        width: size.width,
        height: size.height
      };
      size.width = this.element.offsetWidth * pxRatio;
      size.height = this.element.offsetHeight * pxRatio;
      this.element.width = size.width;
      this.element.height = size.height;

      if (this.container.started) {
        this.resizeFactor = {
          width: size.width / oldSize.width,
          height: size.height / oldSize.height
        };
      }
    }
  }, {
    key: "drawConnectLine",
    value: function drawConnectLine(p1, p2) {
      var _this4 = this;

      this.draw(function (ctx) {
        var _a;

        var lineStyle = _this4.lineStyle(p1, p2);

        if (!lineStyle) {
          return;
        }

        var pos1 = p1.getPosition();
        var pos2 = p2.getPosition();
        (0, Utils_2.drawConnectLine)(ctx, (_a = p1.retina.linksWidth) !== null && _a !== void 0 ? _a : _this4.container.retina.linksWidth, lineStyle, pos1, pos2);
      });
    }
  }, {
    key: "drawGrabLine",
    value: function drawGrabLine(particle, lineColor, opacity, mousePos) {
      var container = this.container;
      this.draw(function (ctx) {
        var _a;

        var beginPos = particle.getPosition();
        (0, Utils_2.drawGrabLine)(ctx, (_a = particle.retina.linksWidth) !== null && _a !== void 0 ? _a : container.retina.linksWidth, beginPos, mousePos, lineColor, opacity);
      });
    }
  }, {
    key: "drawParticle",
    value: function drawParticle(particle, delta) {
      var _this5 = this;

      var _a, _b, _c, _d, _e, _f;

      if (particle.spawning || particle.destroyed) {
        return;
      }

      var pfColor = particle.getFillColor();
      var psColor = (_a = particle.getStrokeColor()) !== null && _a !== void 0 ? _a : pfColor;

      if (!pfColor && !psColor) {
        return;
      }

      var _this$getPluginPartic = this.getPluginParticleColors(particle),
          _this$getPluginPartic2 = _slicedToArray(_this$getPluginPartic, 2),
          fColor = _this$getPluginPartic2[0],
          sColor = _this$getPluginPartic2[1];

      var pOptions = particle.options;
      var twinkle = pOptions.twinkle.particles;
      var twinkling = twinkle.enable && Math.random() < twinkle.frequency;

      if (!fColor || !sColor) {
        var twinkleRgb = (0, Utils_2.colorToHsl)(twinkle.color);

        if (!fColor) {
          fColor = twinkling && twinkleRgb !== undefined ? twinkleRgb : pfColor ? pfColor : undefined;
        }

        if (!sColor) {
          sColor = twinkling && twinkleRgb !== undefined ? twinkleRgb : psColor ? psColor : undefined;
        }
      }

      var options = this.container.actualOptions;
      var zIndexOptions = particle.options.zIndex;
      var zOpacityFactor = Math.pow(1 - particle.zIndexFactor, zIndexOptions.opacityRate);
      var radius = particle.getRadius();
      var opacity = twinkling ? twinkle.opacity : (_d = (_b = particle.bubble.opacity) !== null && _b !== void 0 ? _b : (_c = particle.opacity) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 1;
      var strokeOpacity = (_f = (_e = particle.stroke) === null || _e === void 0 ? void 0 : _e.opacity) !== null && _f !== void 0 ? _f : opacity;
      var zOpacity = opacity * zOpacityFactor;
      var fillColorValue = fColor ? (0, Utils_2.getStyleFromHsl)(fColor, zOpacity) : undefined;

      if (!fillColorValue && !sColor) {
        return;
      }

      this.draw(function (ctx) {
        var zSizeFactor = Math.pow(1 - particle.zIndexFactor, zIndexOptions.sizeRate);
        var zStrokeOpacity = strokeOpacity * zOpacityFactor;
        var strokeColorValue = sColor ? (0, Utils_2.getStyleFromHsl)(sColor, zStrokeOpacity) : fillColorValue;

        if (radius <= 0) {
          return;
        }

        var container = _this5.container;

        var _iterator2 = _createForOfIteratorHelper(container.particles.updaters),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var updater = _step2.value;

            if (updater.beforeDraw) {
              updater.beforeDraw(particle);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        (0, Utils_2.drawParticle)(_this5.container, ctx, particle, delta, fillColorValue, strokeColorValue, options.backgroundMask.enable, options.backgroundMask.composite, radius * zSizeFactor, zOpacity, particle.options.shadow, particle.gradient);

        var _iterator3 = _createForOfIteratorHelper(container.particles.updaters),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _updater = _step3.value;

            if (_updater.afterDraw) {
              _updater.afterDraw(particle);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      });
    }
  }, {
    key: "drawPlugin",
    value: function drawPlugin(plugin, delta) {
      this.draw(function (ctx) {
        (0, Utils_2.drawPlugin)(ctx, plugin, delta);
      });
    }
  }, {
    key: "drawParticlePlugin",
    value: function drawParticlePlugin(plugin, particle, delta) {
      this.draw(function (ctx) {
        (0, Utils_2.drawParticlePlugin)(ctx, plugin, particle, delta);
      });
    }
  }, {
    key: "initBackground",
    value: function initBackground() {
      var options = this.container.actualOptions;
      var background = options.background;
      var element = this.element;
      var elementStyle = element === null || element === void 0 ? void 0 : element.style;

      if (!elementStyle) {
        return;
      }

      if (background.color) {
        var color = (0, Utils_2.colorToRgb)(background.color);
        elementStyle.backgroundColor = color ? (0, Utils_2.getStyleFromRgb)(color, background.opacity) : "";
      } else {
        elementStyle.backgroundColor = "";
      }

      elementStyle.backgroundImage = background.image || "";
      elementStyle.backgroundPosition = background.position || "";
      elementStyle.backgroundRepeat = background.repeat || "";
      elementStyle.backgroundSize = background.size || "";
    }
  }, {
    key: "draw",
    value: function draw(cb) {
      if (!this.context) {
        return;
      }

      return cb(this.context);
    }
  }, {
    key: "initCover",
    value: function initCover() {
      var options = this.container.actualOptions;
      var cover = options.backgroundMask.cover;
      var color = cover.color;
      var coverRgb = (0, Utils_2.colorToRgb)(color);

      if (coverRgb) {
        this.coverColor = {
          r: coverRgb.r,
          g: coverRgb.g,
          b: coverRgb.b,
          a: cover.opacity
        };
      }
    }
  }, {
    key: "initTrail",
    value: function initTrail() {
      var options = this.container.actualOptions;
      var trail = options.particles.move.trail;
      var fillColor = (0, Utils_2.colorToRgb)(trail.fillColor);

      if (fillColor) {
        var _trail = options.particles.move.trail;
        this.trailFillColor = {
          r: fillColor.r,
          g: fillColor.g,
          b: fillColor.b,
          a: 1 / _trail.length
        };
      }
    }
  }, {
    key: "getPluginParticleColors",
    value: function getPluginParticleColors(particle) {
      var fColor;
      var sColor;

      var _iterator4 = _createForOfIteratorHelper(this.container.plugins),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              plugin = _step4$value[1];

          if (!fColor && plugin.particleFillColor) {
            fColor = (0, Utils_2.colorToHsl)(plugin.particleFillColor(particle));
          }

          if (!sColor && plugin.particleStrokeColor) {
            sColor = (0, Utils_2.colorToHsl)(plugin.particleStrokeColor(particle));
          }

          if (fColor && sColor) {
            break;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return [fColor, sColor];
    }
  }, {
    key: "initStyle",
    value: function initStyle() {
      var element = this.element,
          options = this.container.actualOptions;

      if (!element) {
        return;
      }

      var originalStyle = this.originalStyle;

      if (options.fullScreen.enable) {
        this.originalStyle = (0, Utils_2.deepExtend)({}, element.style);
        element.style.setProperty("position", "fixed", "important");
        element.style.setProperty("z-index", options.fullScreen.zIndex.toString(10), "important");
        element.style.setProperty("top", "0", "important");
        element.style.setProperty("left", "0", "important");
        element.style.setProperty("width", "100%", "important");
        element.style.setProperty("height", "100%", "important");
      } else if (originalStyle) {
        element.style.position = originalStyle.position;
        element.style.zIndex = originalStyle.zIndex;
        element.style.top = originalStyle.top;
        element.style.left = originalStyle.left;
        element.style.width = originalStyle.width;
        element.style.height = originalStyle.height;
      }

      for (var key in options.style) {
        if (!key || !options.style) {
          continue;
        }

        var value = options.style[key];

        if (!value) {
          continue;
        }

        element.style.setProperty(key, value, "important");
      }
    }
  }, {
    key: "paintBase",
    value: function paintBase(baseColor) {
      var _this6 = this;

      this.draw(function (ctx) {
        (0, Utils_2.paintBase)(ctx, _this6.size, baseColor);
      });
    }
  }, {
    key: "lineStyle",
    value: function lineStyle(p1, p2) {
      var _this7 = this;

      return this.draw(function (ctx) {
        var options = _this7.container.actualOptions;
        var connectOptions = options.interactivity.modes.connect;
        return (0, Utils_2.gradient)(ctx, p1, p2, connectOptions.links.opacity);
      });
    }
  }]);

  return Canvas;
}();

exports.Canvas = Canvas;